module.exports = __webpack_public_path__ + "static/img/FireBallGahesha-zh.3b44eb56.png";